skyward.base.registerScript('entrywithdrawalspecialprogram', function (skyward, $)
{
    "use strict";
    function initEntryWithdrawalSpecialProgramScript()
    {
        //Individual Special Program Wrapper functions
        $(function ()
        {
            $("input, textarea, div.eELInputContainer").on('errorChange', function ()
            {
                if ($(this).hasClass('error-control'))
                {
                    if (!$(this).closest('.specialProgramContainer').hasClass('error-control'))
                    {
                        $(this).closest('.specialProgramContainer').toggleClass('error-control');
                    }
                }
                else
                {
                    if (($(this).closest('.specialProgramContainer').find('.error-control')[0] === undefined))
                    {
                        if ($(this).closest('.specialProgramContainer').hasClass('error-control'))
                        {
                            $(this).closest('.specialProgramContainer').removeClass('error-control');
                        }
                    }
                }
            });
        });

        $(".specialProgramContainer").each(function ()
        {
            var programContainer = { container: this }
            registerContainerParts(programContainer)
        });

        var programAndRelatedServiceTXIDs = $("#ProgramAndRelatedServiceTXIDs");
        if (programAndRelatedServiceTXIDs.length > 0)
        {
            var programAndRelatedServiceTXIDArray = programAndRelatedServiceTXIDs.val().split(',');
            for (var i = 0; i < programAndRelatedServiceTXIDArray.length; i++)
            {
                var stateProgramAndRelatedServiceTypetest = $("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID" + programAndRelatedServiceTXIDArray[i]);
                if (stateProgramAndRelatedServiceTypetest.length > 0)
                {
                    programandrelatedservicechange(programAndRelatedServiceTXIDArray[i]);

                    var stateProgramAndRelatedServiceOnChange = function ()
                    {
                        programandrelatedservicechange(programAndRelatedServiceTXIDArray[i]);
                    };

                    stateProgramAndRelatedServiceTypetest.on("eelComplete", stateProgramAndRelatedServiceOnChange);
                }
            }
        }
    }

    var registerContainerParts = function (specialProgram)
    {
        specialProgram.fieldsContainer = $(specialProgram.container).find('.fieldWrapper');
        specialProgram.expandButton = $(specialProgram.container).find('#expandButton');
        specialProgram.collapseButton = $(specialProgram.container).find('#collapseButton');

        specialProgram.expandButton.click(function ()
        {
            expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
        specialProgram.collapseButton.click(function ()
        {
            expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
    };

    var expandCollapse = function (specialProgramsContainer, expandButton, collapseButton)
    {
        var wrapper = specialProgramsContainer;
        var isHidden = specialProgramsContainer.hasClass('collapsed');

        if (isHidden)
        {
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else
        {
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    var programandrelatedservicechange = function (programAndRelatedServiceTXID)
    {
        var stateProgramAndRelatedServiceType;

        if (programAndRelatedServiceTXID !== undefined)
        {
            stateProgramAndRelatedServiceType = $("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID" + programAndRelatedServiceTXID + "_description").val();
        }
        else
        {
            var attrName = document.activeElement.name;

            if (attrName !== undefined && attrName.length > 0)
            {
                var nameSplit = attrName.split('.');
                if (nameSplit !== undefined && nameSplit.length > 0)
                {
                    var programAndRelatedServiceWithAppendedDescription = nameSplit[2];
                    stateProgramAndRelatedServiceType = $("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID" + programAndRelatedServiceWithAppendedDescription).val();

                    if (programAndRelatedServiceWithAppendedDescription.length > 0)
                    {
                        programAndRelatedServiceTXID = programAndRelatedServiceWithAppendedDescription.split('_')[0];
                    }
                }
            }
        }

        var interpretingServicesFieldSet = $("#fsStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID);
        var pPCDServiceLocationFieldSet = $("#fsStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID);
        var districtOfRDSPDServiceFieldSet = $("#fsDistrictOfRDSPDService" + programAndRelatedServiceTXID);
        var interpretingServicesCodeEelCodeValue = $("#ProgramAndRelatedServiceTXStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID + "_code");
        var interpretingServicesCodeEelDescriptionValue = $("#ProgramAndRelatedServiceTXStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID + "_description");
        var interpretingServicesID = $("#ProgramAndRelatedServiceTXStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID + "_value");
        var pPCDServiceLocationCodeEelCodeValue = $("#ProgramAndRelatedServiceTXStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID + "_code");
        var pPCDServiceLocationCodeEelDescriptionValue = $("#ProgramAndRelatedServiceTXStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID + "_description");
        var pPCDServiceLocationID = $("#ProgramAndRelatedServiceTXStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID + "_value");
        var districtOfRDSPDServiceTextBoxValue = $("#ProgramAndRelatedServiceTXDistrictOfRDSPDService" + programAndRelatedServiceTXID);

        if (stateProgramAndRelatedServiceType.length > 0)
        {
            switch (stateProgramAndRelatedServiceType.toLowerCase())
            {
                case "interpreting services":
                    interpretingServicesFieldSet.show();
                    pPCDServiceLocationFieldSet.hide();
                    districtOfRDSPDServiceFieldSet.hide();
                    skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                    skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                    skyward.controls.setValue(pPCDServiceLocationID, "");
                    skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                    break;
                case "early childhood special education":
                    interpretingServicesFieldSet.hide();
                    pPCDServiceLocationFieldSet.show();
                    districtOfRDSPDServiceFieldSet.hide();
                    skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                    skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                    skyward.controls.setValue(interpretingServicesID, "");
                    skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                    break;
                case "receiving instructional services from rdspd":
                    interpretingServicesFieldSet.hide();
                    pPCDServiceLocationFieldSet.hide();
                    districtOfRDSPDServiceFieldSet.show();
                    skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                    skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                    skyward.controls.setValue(pPCDServiceLocationID, "");
                    skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                    skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                    skyward.controls.setValue(interpretingServicesID, "");
                    break;
                default:
                    interpretingServicesFieldSet.hide();
                    pPCDServiceLocationFieldSet.hide();
                    districtOfRDSPDServiceFieldSet.hide();
                    skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                    skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                    skyward.controls.setValue(pPCDServiceLocationID, "");
                    skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                    skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                    skyward.controls.setValue(interpretingServicesID, "");
                    skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                    break;
            }
        }
        else
        {
            interpretingServicesFieldSet.hide();
            pPCDServiceLocationFieldSet.hide();
            districtOfRDSPDServiceFieldSet.hide();
            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
            skyward.controls.setValue(pPCDServiceLocationID, "");
            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
            skyward.controls.setValue(interpretingServicesID, "");
            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
        }
    };

    var events =
    {
        "initEntryWithdrawalSpecialProgramScript": initEntryWithdrawalSpecialProgramScript
    };

    return events;
});
//# sourceURL=skyward.ui.entrywithdrawalspecialprogram.js
